import cx from 'classnames';
import { useId } from 'react';
import styles from './PendingSpinner.module.css';

type OwnProps = {
  className?: string;
  inverse?: boolean;
  size?: 'lg' | 'sm';
};

const sizeValues = { lg: 24, sm: 16 };

// Mirrors @carvana/ds-spinner's artwork, but rotates via a CSS transform on an HTML element: that runs on the
// compositor, whereas the DS Spinner's SVG SMIL animation freezes while hydration blocks the main thread.
export default function PendingSpinner({
  className,
  inverse = false,
  size = 'sm'
}: OwnProps) {
  const id = useId();
  const firstHalfId = `${id}-first-half`;
  const secondHalfId = `${id}-second-half`;
  const sizeValue = sizeValues[size];
  const strokeWidth = sizeValue >= 24 ? 2 : 3;

  return (
    <span
      aria-hidden="true"
      className={cx(
        'inline-flex animate-spin motion-reduce:animate-none',
        styles.spinner,
        { [styles.inverse]: inverse },
        className
      )}
      data-testid="pending-spinner"
    >
      <svg
        fill="none"
        height={sizeValue}
        viewBox="0 0 24 24"
        width={sizeValue}
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id={secondHalfId}>
            <stop offset="20%" stopColor="var(--fade-color)" stopOpacity="0" />
            <stop offset="100%" stopColor="currentColor" stopOpacity="1" />
          </linearGradient>
          <linearGradient id={firstHalfId}>
            <stop offset="0%" stopColor="currentColor" stopOpacity="1" />
            <stop offset="100%" stopColor="currentColor" stopOpacity="1" />
          </linearGradient>
        </defs>
        <circle
          cx="12"
          cy="12"
          opacity=".5"
          r="10"
          stroke="var(--fade-color)"
          strokeWidth={strokeWidth}
        />
        <g strokeLinecap="round" strokeWidth={strokeWidth}>
          <path
            d="M 2 12 A 10 10 0 0 1 22 12"
            stroke={`url(#${secondHalfId})`}
          />
          <path
            d="M 22 12 A 10 10 0 0 1 2 12"
            stroke={`url(#${firstHalfId})`}
          />
          <path
            d="M 2 12 A 10 10 0 0 1 2 11.8"
            stroke="currentColor"
            strokeLinecap="round"
          />
        </g>
      </svg>
    </span>
  );
}
